(function($){
    $('body').on('click', '.gallery-nav.next-arrow', function(e){
        e.preventDefault();
        $('.flex-control-thumbs li').each(function(){
            if($(this).find('.flex-active').length > 0 && $(this).next('li').length > 0){
                $(this).find('.flex-active').removeClass('flex-active');
                $(this).next('li').find('img').click();
                return false;
            }
        })
    });
    $('body').on('click', '.gallery-nav.prev-arrow', function(e){
        e.preventDefault();
        $('.flex-control-thumbs li').each(function(){
            if($(this).find('.flex-active').length > 0 && $(this).prev('li').length > 0){
                $(this).find('.flex-active').removeClass('flex-active');
                $(this).prev('li').find('img').click();
                return false;
            }
        })
    })
})(jQuery)